import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useLocation } from 'react-router-dom';
import { ClipboardCheck, X } from 'lucide-react';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Sticky banner shown on every Nakes page when there's an open Stok Opname
 * request the nakes hasn't submitted yet. Auto-hides on submit or close.
 *
 * Dismissed (local-only) when user clicks X — re-appears on next reload.
 */
export default function StokOpnameBanner() {
  const [active, setActive] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    const check = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) return;
        const res = await axios.get(`${API}/stock-opname/active`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (cancelled) return;
        if (res.data?.has_active) {
          setActive(res.data);
        } else {
          setActive(null);
        }
      } catch (_e) {
        /* silent — never block the page */
      }
    };
    check();
    return () => { cancelled = true; };
  }, [location.pathname]);

  // Hide banner on the Stok Opname page itself (user is already there).
  // Only show when there's an active request the nakes hasn't submitted yet.
  if (!active || dismissed || active.already_submitted || location.pathname.startsWith('/nakes/stok-opname')) {
    return null;
  }

  return (
    <div
      className="bg-amber-50 border-b border-amber-200 px-4 py-2.5 flex items-center gap-3 text-amber-900 text-sm"
      data-testid="stok-opname-banner"
    >
      <ClipboardCheck className="w-5 h-5 flex-shrink-0 text-amber-600" />
      <div className="flex-1 min-w-0">
        <p className="font-medium">Request Stok Opname dari Admin</p>
        <p className="text-xs text-amber-700 mt-0.5">
          Mohon submit stok barang yang ada di tanganmu. {active.deadline && `Deadline: ${active.deadline}`}
        </p>
      </div>
      <Link
        to="/nakes/stok-opname"
        className="bg-amber-600 hover:bg-amber-700 text-white text-xs font-medium px-3 py-1.5 rounded whitespace-nowrap"
        data-testid="banner-open-btn"
      >
        Isi Sekarang
      </Link>
      <button
        onClick={() => setDismissed(true)}
        className="text-amber-600 hover:text-amber-800 flex-shrink-0"
        aria-label="Tutup"
        data-testid="banner-dismiss-btn"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}
